
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hero",
      function () {
        return require("private-next-pages/hero/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hero"])
      });
    }
  